import React from 'react';
import axios from 'src/common/axiosInstance';
import PersonMemoryEditor from './PersonMemoryEditor';

export default function AiPersonMemory({ conversationId, refreshVersion }) {
  const url = `/conversations/${conversationId}/ai/memory`;
  return <PersonMemoryEditor resourceKey={conversationId} refreshVersion={refreshVersion}
    load={async () => (await axios.get(url)).data}
    save={async payload => (await axios.put(url, payload)).data} />;
}
